import React, { useEffect, useRef, useState } from 'react'
import { IoHomeSharp } from 'react-icons/io5'
import './sideMenu.css'
import CourseHome from './courseHome'
import { useAuth } from '../../context/AuthContext'
import CourseNav from './CourseNav'
import LogInInfo from './LogInInfo'
import { GetDataCoursesServices } from '../../services/getDataCourses/GetDataCoursesServices'
import { SetProgressUserTopicContent } from '../../services/setProgressUserTopicContent/SetProgressUserTopicContent'
import ModulesComponent from './ModulesComponent'
import ContentComponent from './ContentComponent'
import { useContextProyect } from '../../context/ContextProyect'
import logsUserService from '../../services/LogsUserActionService'
import CertificatesButtonComponent from '../certificates/CertificatesButtonComponent'

const CourseExternalComponent = ({ course }) => {
  const { token, idUser } = useAuth();
  const [dataCourseE, setDataCourseE] = useState('');
  const [errorData, setErrorData] = useState('');
  const [sendProgress, setSendProgress] = useState('');

  const [currentModule, setCurrentModule] = useState(-1)
  const [currentSubmodule, setCurrentSubmodule] = useState(0)
  const [currentTopic, setCurrentTopic] = useState(0)

  const [openModule, setOpenModule] = useState(currentModule)

  const [prevDisabled, setPrevDisabled] = useState(false)
  const [nextDisabled, setNextDisabled] = useState(false)

  const [menuState, setMenuState] = useState('closedIfSmall')
  const [home, setHome] = useState(true);
  const { reloadCourse, setReloadCourse, setReloadProgress } = useContextProyect();
  const reportedTopics = useRef(new Set());
  const lastLoggedContentId = useRef(null);
  const [hasSentProgress, setHasSentProgress] = useState(false);

  useEffect(() => {

    const getDataCourseE = async () => {

      const responseDataCourse = await GetDataCoursesServices(token, course.id);

      if (responseDataCourse.errors) {
        setErrorData(responseDataCourse.message);
        setDataCourseE(null);
      } else {
        setErrorData(null);
        setDataCourseE(responseDataCourse.data);
      }
      setHasSentProgress((prev) => !prev);
    }

    getDataCourseE();

  }, [token, idUser, reloadCourse])

  useEffect(() => {
    if (reloadCourse) {
      reportedTopics.current = new Set();
    }
  }, [reloadCourse])

  useEffect(() => {
    if (!home && dataCourseE && dataCourseE.modules && dataCourseE.modules.length > 0) {
      let modIndex = currentModule;
      if (modIndex < 0) {
        modIndex = 0;
        setCurrentModule(0);
      }
      const initialModule = dataCourseE.modules[modIndex];
      if (initialModule && initialModule.topics && initialModule.topics.length > 0) {
        const initialSubmodule = initialModule.topics[currentSubmodule];
        const initialContentId = initialSubmodule.content_topics[currentTopic]?.id;
        const initialTitle = initialSubmodule.content_topics[currentTopic]?.title || "Contenido sin título";
        const submoduleTitle = initialSubmodule.title || "Submódulo sin título";

        const isLastModule = modIndex === dataCourseE.modules.length - 1;
        const isLastSubmodule = currentSubmodule === initialModule.topics.length - 1;
        const isLastTopic = currentTopic === initialSubmodule.content_topics.length - 1;

        // Siempre reportar progreso y log si no ha sido reportado aún
        if (initialContentId && !reportedTopics.current.has(initialContentId)) {
          reportProgress(initialContentId);
          reportedTopics.current.add(initialContentId);

          const action = `Clic en el contenido: ${initialTitle} dentro del topic: ${submoduleTitle}`;
          logsUserService(idUser, action, token);
        }

        // Si es el último contenido, registrar acción extra si no se ha hecho
        if (
          initialContentId &&
          isLastModule &&
          isLastSubmodule &&
          isLastTopic &&
          !reportedTopics.current.has(`LAST-${initialContentId}`)
        ) {
          const lastAction = `Clic en el contenido: ${initialTitle} dentro del topic: ${submoduleTitle}`;
          logsUserService(idUser, lastAction, token);
          reportedTopics.current.add(`LAST-${initialContentId}`);
        }
      }
    }
  }, [home, dataCourseE, currentModule, currentSubmodule, currentTopic, reloadCourse]);


  function switchOpenModule(index) {
    if (index === openModule) {
      setOpenModule(-1)
    } else {
      setOpenModule(index)
    }
  }

  function changeSubmodule(moduleIndex, submoduleIndex) {
    setCurrentModule(moduleIndex)
    setCurrentSubmodule(submoduleIndex)
    setCurrentTopic(0)

    updateNextDisabled(moduleIndex, submoduleIndex, 0);

    if (moduleIndex === 0 && submoduleIndex === 0) {
      setPrevDisabled(true)
    } else setPrevDisabled(false)

    setHome(false)
  }

  const reportProgress = async (content_topic_id) => {
    console.log("Reportando progreso para:", content_topic_id);

    try {
      const SendDataProgress = await SetProgressUserTopicContent(token, idUser, content_topic_id);
      if (SendDataProgress.errors) {
        setErrorData(SendDataProgress.message);
        setSendProgress(null);
      } else {
        setErrorData(null);
        setSendProgress(SendDataProgress.message);
      }

      setReloadCourse((load) => !load);
    } catch (error) {
      console.error("Error en reportProgress:", error);
      setErrorData("Ocurrió un error inesperado.");
    }

  }

  console.log('reportProgress', sendProgress);

  function updateNextDisabled(moduleIndex, submoduleIndex, topicIndex) {
    // Se asume que modules está definido y que moduleIndex, submoduleIndex y topicIndex son válidos.
    const lastModuleIndex = modules.length - 1;
    const lastSubmoduleIndex = modules[moduleIndex].topics.length - 1;
    const lastTopicIndex = modules[moduleIndex].topics[submoduleIndex].content_topics.length - 1;

    if (
      moduleIndex === lastModuleIndex &&
      submoduleIndex === lastSubmoduleIndex &&
      topicIndex === lastTopicIndex
    ) {
      setNextDisabled(true);
    } else {
      setNextDisabled(false);
    }
  }


  function onNext() {
    // Obtener el módulo y submódulo actual
    const currentModuleData = modules?.[currentModule];
    if (!currentModuleData) return;

    const currentSubmoduleData = currentModuleData.topics[currentSubmodule];
    if (!currentSubmoduleData) return;

    const currentContentTopic = currentSubmoduleData.content_topics[currentTopic];
    const submoduleTitle = currentSubmoduleData.title;
    const action = `Clic en el contenido: ${currentContentTopic.title} dentro del topic: ${submoduleTitle}`;
    logsUserService(idUser, action, token);

    // Variables locales para calcular el siguiente paso:
    let nextModule = currentModule;
    let nextSubmodule = currentSubmodule;
    let nextTopic = currentTopic;

    // Caso 1: Aún hay más topics en el mismo submódulo.
    if (currentTopic < currentSubmoduleData.content_topics.length - 1) {
      nextTopic = currentTopic + 1;
    }
    // Caso 2: Es el último topic del submódulo, pero hay otro submódulo en el mismo módulo.
    else if (currentSubmodule < currentModuleData.topics.length - 1) {
      nextSubmodule = currentSubmodule + 1;
      nextTopic = 0;
    }
    // Caso 3: Es el último submódulo del módulo, pero hay otro módulo.
    else if (currentModule < modules.length - 1) {
      nextModule = currentModule + 1;
      nextSubmodule = 0;
      nextTopic = 0;
    }
    // Caso 4: Es el último contenido de todo el curso.
    else {
      // Reporta el progreso del último content_topic (por si no se registró)
      const lastContentId = currentSubmoduleData.content_topics[currentTopic].id;
      const lastContent = currentSubmoduleData.content_topics[currentTopic];
      if (lastContentId && !reportedTopics.current.has(lastContentId)) {
        reportProgress(lastContentId);
        reportedTopics.current.add(lastContentId);
      }
      setNextDisabled(true);
      return; // No hay más contenido.
    }

    // Con los índices del próximo contenido, obtenemos el ID:
    const nextContentTopicId = modules[nextModule]
      ?.topics[nextSubmodule]
      ?.content_topics[nextTopic]?.id;

    if (nextContentTopicId && !reportedTopics.current.has(nextContentTopicId)) {
      reportProgress(nextContentTopicId);
      setHasSentProgress((prev) => !prev);
      reportedTopics.current.add(nextContentTopicId);
    }

    // Actualizamos los estados con los nuevos índices.
    setCurrentModule(nextModule);
    setCurrentSubmodule(nextSubmodule);
    setCurrentTopic(nextTopic);
    setOpenModule(nextModule); // Se asume que abres el módulo del próximo contenido.
    setPrevDisabled(false);

    updateNextDisabled(nextModule, nextSubmodule, nextTopic);
  }


  const onPrev = () => {
    const module = modules?.[currentModule];
    if (!module) return;

    const submodule = module.topics?.[currentSubmodule];
    if (!submodule) return;

    if (currentTopic === 0) {
      // The first topic of the submodule

      if (currentSubmodule === 0) {
        // The first submodule of the module

        if (currentModule === 0) {
          // The first module

          setPrevDisabled(true)
          return
        } else {
          // Go to the previous module
          const prevModule = modules[currentModule - 1]
          setCurrentSubmodule(prevModule.topics.length - 1)
          setCurrentTopic(
            prevModule.topics[prevModule.topics.length - 1].content_topics
              .length - 1
          )
          setCurrentModule(currentModule - 1)
          setOpenModule(currentModule - 1)
          setNextDisabled(false)
        }
      } else {
        // Go to the Previous submodule
        setCurrentSubmodule(currentSubmodule - 1)
        setCurrentTopic(
          modules[currentModule].topics[currentSubmodule - 1].content_topics
            .length - 1
        )
        setPrevDisabled(false)
      }
    } else {
      // Previous topic of the submodule
      setCurrentTopic(currentTopic - 1)
      setNextDisabled(false)
    }
  }

  function handleHome(e) {
    e.preventDefault()

    setHome(true)

    setCurrentModule(-1)
    setCurrentSubmodule(-1)
    setOpenModule(-1)
    setReloadCourse((load) => !load);
    setReloadProgress((loadProgress) => !loadProgress);

    const action = `Clic en botón de inicio: ${dataCourseE?.course?.title} `;
    logsUserService(idUser, action, token);
  }

  function toggleMenu() {
    let classN = ''

    switch (menuState) {
      case 'closedIfSmall':
      case 'sidebar-collapse':
        classN = 'sidebar-expand'
        break
      case 'sidebar-expand':
        classN = 'sidebar-collapse'
        break

      default:
        classN = 'sidebar-collapse'
        break
    }

    setMenuState(classN)
  }

  function goToModule(moduleIndex) {
    // changeSubmodule(moduleIndex, 0)
    // setCurrentModule(moduleIndex)
    // setCurrentSubmodule(0)
    // setOpenModule(moduleIndex)


    // Obtenemos el módulo seleccionado
    const mod = modules[moduleIndex];

    if (mod && mod.topics && mod.topics.length > 0) {
      // Buscar el último topic disponible (is_available true)
      // Puedes hacerlo de dos formas: filtrando el array o recorriéndolo en reversa.
      let lastAvailableIndex = 0;
      for (let i = mod.topics.length - 1; i >= 0; i--) {
        if (mod.topics[i].is_available) {
          lastAvailableIndex = i;
          break;
        }
      }

      // Utiliza ese índice para cambiar de submódulo y reinicia el topic a 0.
      changeSubmodule(moduleIndex, lastAvailableIndex);
      setCurrentModule(moduleIndex);
      setCurrentSubmodule(lastAvailableIndex);
      setCurrentTopic(0);
      setOpenModule(moduleIndex);
    }
  }

  const modules = dataCourseE?.modules

  return (
    <main className='h-screen w-screen max-h-screen flex flex-col'>
      <CourseNav toggleMenu={toggleMenu} />
      {/* Content */}

      <div className={'text-white grow flex oversflow-scroll '}>
        <div
          className={
            'bg-dark-dark-purple flex flex-col items-stretch justify-start max-w-60 min-w-[min(100vw,15rem)] relative z-10 ' +
            menuState
          }>

          <button
            className={
              'flex items-center justify-center gap-2 mt-10 transition-colors duration-300 ease-in-out mx-3 py-3 min-w-52' +
              ' ' +
              (home ? 'bg-light-green' : '')
            }
            onClick={handleHome}
          >
            <IoHomeSharp />
            Inicio
          </button>

          {/* {console.log({ PEPE: dataCourseE?.course?.progress_course })} */}

          <div className='flex flex-col justify-end '>
            <CertificatesButtonComponent dataCourse={dataCourseE?.course} hasSentProgress={hasSentProgress} />
          </div>

          {modules?.map((module, i) => {
            return (
              <ModulesComponent
                topics={module.topics}
                currentSubmodule={currentSubmodule}
                currentModule={currentModule}
                title={module.title}
                key={i}
                opened={openModule}
                onSwitch={() => switchOpenModule(i)}
                onClick={changeSubmodule}
                index={i}
                disabled={!module.is_available}
              />
            )
          })}

          <LogInInfo className='flex lg:hidden z-10' />

          <div className='absolute bottom-10 right-0 left-0 flex justify-center z-0 pointer-events-none'>
            <img src='/images/icons/logo-novo-white.png' className='w-24' />
          </div>

        </div>
        {!home && (
          // Componente que el contenido del curso - imagenes
          <ContentComponent
            topics={modules[currentModule].topics}
            currentSubmodule={currentSubmodule}
            currentTopic={currentTopic}
            title={modules[currentModule].title}
            onNext={onNext}
            onPrev={onPrev}
            nextDisabled={nextDisabled}
            prevDisabled={prevDisabled}
          />
        )}
        {home && (
          // Componente que nos muestra el Home del curso
          <CourseHome
            courseId={course.id}
            modules={modules}
            onClick={goToModule}
          />
        )}
      </div>
    </main>
  )
}


export default CourseExternalComponent
